/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmDailyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setUserTransactionCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/user/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setUserTransactionCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/user/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTpsUntil({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/tps',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTpsUntil1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/tps',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalTrxGasUsed({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/total/gasused',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalTrxGasUsed1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/total/gasused',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyTransactionTokenChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/token/chart',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyTransactionTokenChart1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/token/chart',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteOldTrxPending(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/pending/old',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteOldTrxPending1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/pending/old',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyPendingTransactionCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/pending/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyPendingTransactionCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/pending/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNormalTransactionCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/normal/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNormalTransactionCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/normal/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyInternalTransactionCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/internal/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyInternalTransactionCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/internal/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyDepositTransactionCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/deposit/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyDepositTransactionCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/deposit/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyClaimTransactionCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/claim/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyClaimTransactionCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/claim/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTransactionAvgGasPrice({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/transaction/avg/gas/price',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTransactionAvgGasPrice1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/avg/gas/price',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTokenInfoMview(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/token/mview/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTokenInfoMview1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/token/mview/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenHolderHistoricalCountDayV2(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/token/holder/historical/count/day/v2',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenHolderHistoricalCountDayV21(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/token/holder/historical/count/day/v2',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenHolderHistoricalCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/token/holder/historical/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenHolderHistoricalCount1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/token/holder/historical/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalSubnetCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/subnet/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalSubnetCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/subnet/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalSubnetCallCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/subnet/call/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalSubnetCallCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/subnet/call/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setStorageSubmissionUploadCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/storage/submission/upload/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setStorageSubmissionUploadCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/storage/submission/upload/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setWeeklyNexonMsuUniqueActiveWallet({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/week/msu/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setWeeklyNexonMsuUniqueActiveWallet1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/week/msu/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonNxpcHolders({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/token/nxpc/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonNxpcHolders1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/token/nxpc/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonNftHolders({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/token/nft/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonNftHolders1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/token/nft/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonErc20TokenHolders({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/token/erc20/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonErc20TokenHolders1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/token/erc20/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setRetentionRateAndUserStickiness({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/retention/stickiness',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setRetentionRateAndUserStickiness1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/retention/stickiness',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonNftContractHolder({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/nft/contract/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonNftContractHolder1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/nft/contract/holder',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonNftCardActivityMetrics({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/nft/activity/metrics',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonNftCardActivityMetrics1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/nft/activity/metrics',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonMsuTotalUsers({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/msu/total/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonMsuTotalUsers1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/msu/total/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonNewRegisteredUsers({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/msu/new/registered/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonNewRegisteredUsers1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/msu/new/registered/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonMsnUniqueActiveWellet({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/msn/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonMsnUniqueActiveWellet1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/msn/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonMsnUniqueActiveAddress({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/msn/uaa',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNexonMsnUniqueActiveAddress1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/msn/uaa',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMonthlyNexonMsuUniqueActiveWallet({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/month/msu/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMonthlyNexonMsuUniqueActiveWallet1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/month/msu/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMarketplaceTraders({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/marketplace/traders',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMarketplaceTraders1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/marketplace/traders',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateLwCirculatingSupplyHistorical({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/livewatch/circulating-supply-historical',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateLwCirculatingSupplyHistorical1({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/livewatch/circulating-supply-historical',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateLwCirculatingSupply({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/livewatch/circulating-supply',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateLwCirculatingSupply1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/livewatch/circulating-supply',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public aggregateBurnWeeklyHistoryByDateRange({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/livewatch/burn-weekly-history/by/date-range',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public aggregateBurnWeeklyHistoryByDateRange1({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/livewatch/burn-weekly-history/by/date-range',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public aggregateBurnWeeklyHistory({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/livewatch/burn-weekly-history',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public aggregateBurnWeeklyHistory1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/livewatch/burn-weekly-history',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonMsuUniqueActiveWallet({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/nexon/day/msu/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNexonMsuUniqueActiveWallet1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/nexon/day/msu/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcPalmScanCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/humanity/vc/verified/palm/scan',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcPalmScanCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/humanity/vc/verified/palm/scan',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcTotalIssuer({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/humanity/vc/issuer/total',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcTotalIssuer1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/humanity/vc/issuer/total',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcTopIssuer(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/humanity/vc/issuer/top',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcTopIssuer1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/humanity/vc/issuer/top',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcIssuance({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/humanity/vc/issuance',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setVcIssuance1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/humanity/vc/issuance',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public evictAllVcTotalUsers({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/general/vc/user/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public evictAllVcTotalUsers1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/general/vc/user/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyValidatorCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/general/validator/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyValidatorCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/general/validator/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNetworkUtilizationAvg({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/general/network/utilization',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNetworkUtilizationAvg1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/general/network/utilization',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBurntFeeCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/general/burntfee/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBurntFeeCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/general/burntfee/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyMedianGasPrice({
        startDate,
        endDate,
    }: {
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/gas/median/fee',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyMedianGasPrice1({
        startDate,
        endDate,
    }: {
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/gas/median/fee',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyAverageTrxBaseFee({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/block/transaction/basefee/average',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyAverageTrxBaseFee1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/block/transaction/basefee/average',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBlockCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/block/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBlockCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/block/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBlockAvgCreatedTime({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/block/avgcreatedtime',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBlockAvgCreatedTime1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/block/avgcreatedtime',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNewRegisteredAgent({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/agent/new/registered',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyNewRegisteredAgent1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/agent/new/registered',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setUawCalledAgents({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/agent/call/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setUawCalledAgents1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/agent/call/uaw',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalAgentCallCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/agent/call/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalAgentCallCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/agent/call/total/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setAddressUniqueActiveAddressCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/uaa',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setAddressUniqueActiveAddressCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/uaa',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenImage(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/token/image',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenImage1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/token/image',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setExecuteTrxAccountCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/execute/transaction/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setExecuteTrxAccountCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/execute/transaction/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setCumulativeUsers({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/cumulative/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setCumulativeUsers1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/cumulative/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyAddressCreatedCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/create/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyAddressCreatedCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/create/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setAverageAccountTrxCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/average/transaction/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setAverageAccountTrxCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/average/transaction/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setActiveUsers({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/daily/address/active/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setActiveUsers1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/address/active/users',
            query: {
                'targetDate': targetDate,
            },
        });
    }

}
